import { Grid } from "@material-ui/core";
import RichTextInput from 'ra-input-rich-text';
import React, { useState } from "react";
import {
    Create,
    FormTab,
    required,
    SelectInput,
    TabbedForm,
    TextInput,
    useRedirect
} from "react-admin";
import AddNewClientButton from "./add-new-client-button";

const choices = [{ id: "IN_PERSON", name: "Presencial" }, { id: "ONLINE", name: "Online" }, { id: "BY_PHONE", name: "Por telefone" }]

const ServiceRequestCreate = (props) => {
    const data = props.history.location.state ? props.history.location.state.data : undefined;
    const [selected, setSelected] = useState(data)
    const redirect = useRedirect()

    const onSuccess = ({ data }) => {
        redirect(`/service-requests/${data.id}/attachments`)
    }

    return (
        <Create {...props} title="Novo pedido de atendimento" onSuccess={onSuccess}>
            <TabbedForm>
                <FormTab label={'Cliente'}>
                    <TextInput source="client.id" style={{ display: 'none' }} initialValue={selected?.id} type="hidden" hidden={true} disabled />
                    <TextInput label={'Nome'} source="client.name" initialValue={selected?.name} fullWidth disabled />
                    <TextInput label={'Email'} source="client.email" initialValue={selected?.email} fullWidth disabled />
                    <TextInput label={'Telefone'} source="client.phone" initialValue={selected?.phone} fullWidth disabled />
                    <Grid container>
                        <AddNewClientButton redirectTo={'/service-requests/create/general'} setSelected={setSelected} />
                    </Grid>
                </FormTab>
                <FormTab label={'Dados Gerais'} path={"general"}>
                    <SelectInput source="origin" label={'Origem'} choices={choices} optionText={"name"} optionValue={"name"} defaultValue={"IN_PERSON"} validate={[required()]} fullWidth />
                    <RichTextInput source="description" label={'Breve relato'} validate={[required()]} fullWidth />
                </FormTab>
            </TabbedForm>
        </Create >
    )
}

export default ServiceRequestCreate;